import { render, staticRenderFns } from "./CCRReportData.vue?vue&type=template&id=f0c0f320&"
import script from "./CCRReportData.vue?vue&type=script&lang=js&"
export * from "./CCRReportData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports